module.exports = __webpack_public_path__ + "static/media/landingPageImage.2428bc4b.png";